import gsap from 'gsap'
import ResizeService from '@/services/ResizeService'
import { mapState, mapMutations } from 'vuex'
import { PATHS } from 'src/config/app'

export default {

  computed: { 
    ...mapState('app', [ 'home', 'motion_clamp' ]) 
  },

  data() {
    return { }
  },

  props: {},

  mounted(){ },

  beforeDestroy() { },

  methods: { 

    leave(el, done){  
      gsap.to( el, {
        duration: ( 0.5 * this.motion_clamp ),
        opacity: 0,
        ease: 'expo.out',
        onComplete: done
      })  
    },

    enter(el, done){ 
      gsap.fromTo( el, {
        x: window.innerWidth * 0.15
      }, { 
        duration: ( 1.8 * this.motion_clamp ),
        x: 0,
        delay: 0.2,
        ease: 'expo.out'
      }) 

      gsap.fromTo( el , {
        opacity: 0 
      }, {
        duration: ( 1 * this.motion_clamp ),
        opacity: 1, 
        delay: 0.2,
        ease: 'expo.out'
      }) 
      done()
    }
  },

  watch: { }
}